import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, HostBinding, input, Signal } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import iconLibrary from 'src/app/common/iconLibrary';

export enum WidgetErrorKind {
  UNKNOWN,
  NOT_FOUND,
  UNAUTHORIZED
}

@Component({
  selector: 'rpt-element-error',
  standalone: true,
  imports: [TranslocoModule, CommonModule],
  templateUrl: './element-error.component.html',
  styleUrl: './element-error.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElementErrorComponent {
  public readonly error = input.required<WidgetErrorKind | Error | undefined | null>();

  protected readonly displayedError: Signal<WidgetErrorKind | null> = computed(() => {
    const error: WidgetErrorKind | Error | null | undefined = this.error();

    if (!error) {
      return null;
    }

    if ('status' in (error as any) || error instanceof Error) {
      const status: unknown = error['status'] as unknown;

      if (status === 404) {
        return WidgetErrorKind.NOT_FOUND;
      }

      if (status === 401) {
        return WidgetErrorKind.UNAUTHORIZED;
      }

      return WidgetErrorKind.UNKNOWN;
    }

    return error;
  });

  @HostBinding('attr.hidden')
  protected get hidden(): true | null {
    return this.displayedError() !== null ? null : true;
  }

  protected readonly ErrorKind = WidgetErrorKind;
  protected readonly iconLibrary = iconLibrary;
}
